// src/serviceWorkerRegistration.js
let registration = null;

export function register() {
  if (
    typeof window === 'undefined' ||
    !('serviceWorker' in navigator) ||
    navigator.userAgent.includes('ReactSnap')
  ) {
    return;
  }

  const swUrl = `/service-worker.js?t=${Date.now()}`;
  navigator.serviceWorker.register(swUrl)
    .then(reg => {
      registration = reg;
    })
    .catch(() => {
      // نادیده بگیر در react-snap
    });
}

export function forceUpdate() {
  if (registration) {
    registration.update();
  }
}